import { useLayoutEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useSearch } from "../../../contexts/SearchContext";

/**
 * Replaces a bare <Navigate to="/p/dashboard/searchoffer" /> so leaving organized-tours
 * clears ORGANIZED_TOURS tab state (see switchFromOrganizedToursIfNeeded).
 */
export default function SearchPackagesToSearchOfferRedirect() {
  const { switchFromOrganizedToursIfNeeded } = useSearch();
  const navigate = useNavigate();
  useLayoutEffect(() => {
    switchFromOrganizedToursIfNeeded(PACKAGES);
    navigate("/p/dashboard/searchoffer", { replace: true });
  }, [navigate, switchFromOrganizedToursIfNeeded]);
  return null;
}
